/* global redirectUrl, refreshCommitmentDataUrl storeUrl ordersListUrl procurementsDashboardUrl financialOverviewUrl uncommittedExpendituresPreCommitUrl */
/* global getProcurementMilestonesUrl updateProcurementMilestonesUrl minDate maxDate listUsersUrl integrationConfigured vikEnabled */
/* global dcApprovalEmailEnabled dcApprovalEmailRecipients */
/* global currentUserId uncommittedExpenditureGroupId departmentName costcentreName draftDestroyUrl draftSaveUrl draftData uncommittedExpendituresUpdateUrl */
/* global supplierRequestStoreUrl supplierRequestSuggestionsUrl supplierRequestRecipients syncSuppliersEnabled groupSupplierId */
/* global existingSupplierRequest supplierRequestConfirmUrl supplierRequestRejectUrl supplierRequestWithdrawUrl */

import { React, useState } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';

import DirectCommitForm from './DirectCommitForm';

import { idempotencyHeader } from 'Helpers/apiUtils';

import { UsersProvider } from 'Context/UsersContext';

export default function DirectCommitment(props) {
    const [mutationHeader, setMutationHeader] = useState(idempotencyHeader());

    return (
        <DirectCommitForm
            redirectUrl={redirectUrl}
            refreshCommitmentDataUrl={refreshCommitmentDataUrl}
            storeUrl={storeUrl}
            ordersListUrl={ordersListUrl}
            procurementsDashboardUrl={procurementsDashboardUrl}
            financialOverviewUrl={financialOverviewUrl}
            uncommittedExpendituresPreCommitUrl={uncommittedExpendituresPreCommitUrl}
            mutationHeader={mutationHeader}
            getExpenseMilestonesUrl={getProcurementMilestonesUrl}
            updateExpenseMilestonesUrl={updateProcurementMilestonesUrl}
            minDate={minDate}
            maxDate={maxDate}
            listUsersUrl={listUsersUrl}
            integrationConfigured={integrationConfigured}
            syncSuppliersEnabled={typeof syncSuppliersEnabled !== 'undefined' ? syncSuppliersEnabled : 0}
            groupSupplierId={typeof groupSupplierId !== 'undefined' ? groupSupplierId : null}
            vikEnabled={vikEnabled}
            currentUserId={currentUserId}
            uncommittedExpenditureGroupId={uncommittedExpenditureGroupId}
            departmentName={departmentName}
            costcentreName={costcentreName}
            draftDestroyUrl={draftDestroyUrl}
            draftSaveUrl={typeof draftSaveUrl !== 'undefined' ? draftSaveUrl : ''}
            draftData={typeof draftData !== 'undefined' ? draftData : null}
            uncommittedExpendituresUpdateUrl={typeof uncommittedExpendituresUpdateUrl !== 'undefined' ? uncommittedExpendituresUpdateUrl : ''}
            supplierRequestStoreUrl={typeof supplierRequestStoreUrl !== 'undefined' ? supplierRequestStoreUrl : ''}
            supplierRequestSuggestionsUrl={typeof supplierRequestSuggestionsUrl !== 'undefined' ? supplierRequestSuggestionsUrl : ''}
            supplierRequestRecipients={typeof supplierRequestRecipients !== 'undefined' ? supplierRequestRecipients : []}
            existingSupplierRequest={typeof existingSupplierRequest !== 'undefined' ? existingSupplierRequest : null}
            supplierRequestConfirmUrl={typeof supplierRequestConfirmUrl !== 'undefined' ? supplierRequestConfirmUrl : ''}
            supplierRequestRejectUrl={typeof supplierRequestRejectUrl !== 'undefined' ? supplierRequestRejectUrl : ''}
            supplierRequestWithdrawUrl={typeof supplierRequestWithdrawUrl !== 'undefined' ? supplierRequestWithdrawUrl : ''}
            dcEmailEnabled={typeof dcApprovalEmailEnabled !== 'undefined' ? dcApprovalEmailEnabled : false}
            dcDefaultRecipients={typeof dcApprovalEmailRecipients !== 'undefined' ? dcApprovalEmailRecipients : []}
        />
    );
}

if (document.getElementById('DirectCommitment')) {
    var root = document.getElementById('DirectCommitment');
    ReactDOM.render(
        <App>
            <UsersProvider fetchUrl={listUsersUrl}>
                <DirectCommitment />
            </UsersProvider>
        </App>,
        root,
    );
}
